import React from "react";
import Box from "@mui/joy/Box";
import { LineChart } from "@mui/x-charts/LineChart";
import { ChartGranularity } from "../../../../models/bidAnalytics";
import { formatBucketLabel } from "../rollup";

export type SeriesDef = {
    dataKey: string;
    label: string;
    color: string;
    valueFormatter?: (v: number | null) => string;
};

type Props = {
    dataset: Array<Record<string, any> & { x: Date }>;
    series: SeriesDef[];
    granularity: ChartGranularity;
    height?: number;
};

export function AnalyticsSeriesChart(props: Props) {
    const { dataset, series, granularity, height = 280 } = props;
    const isSmall = typeof window !== "undefined" && window.innerWidth < 600;

    if (dataset.length === 0) {
        return null;
    }

    return (
        <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Box sx={{ minWidth: isSmall ? Math.max(480, dataset.length * 28) : undefined }}>
                <LineChart
                    height={height}
                    dataset={dataset}
                    xAxis={[
                        {
                            dataKey: "x",
                            scaleType: "time",
                            valueFormatter: (v: Date) => formatBucketLabel(v, granularity),
                        },
                    ]}
                    series={series.map((s) => ({
                        dataKey: s.dataKey,
                        label: s.label,
                        color: s.color,
                        showMark: !isSmall && dataset.length <= 40,
                        valueFormatter: s.valueFormatter ?? ((v: number | null) =>
                            v == null ? "—" : v.toLocaleString("ru-RU")),
                    }))}
                    margin={{ left: 60, right: 20, top: 20, bottom: 40 }}
                />
            </Box>
        </Box>
    );
}
